exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resource-filter {\n  height: 100%;\n}\n.resource-filter .property-select {\n  width: 150px;\n}\n.resource-filter .read-only-value {\n  display: block;\n  font-weight: 500;\n}\n.resource-filter .select-toggle {\n  margin-bottom: 20px;\n}\n.resource-filter h4 {\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n.resource-filter .form-group {\n  margin-bottom: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/resources/filter/filter.component.less
// module id = ../../../../../src/app/components/resources/filter/filter.component.less
// module chunks = main